import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import Address from "./Address"
import Location from "./Location"
import RequestLocation from "./RequestLocation"

export enum AssetShippingStatus {
    torelease = "torelease",
    released = "released",
    stored = "stored",
}

export interface IGetShippingOrderAssetDto {
    assetId: Guid
    plannedAssetId?: Guid | null
    status: AssetShippingStatus
    releaseDate?: string  | null
    storeDate?: string | null
    transportId?: Guid | null
    transportSequence?: number | null
    departureLocationId: Guid
    arrivalLocationId: Guid
    inspectionRequired: boolean
}

export default class ShippingOrderAsset {
    assetId: Guid
    plannedAssetId?: Guid
    status: AssetShippingStatus
    releaseDate?: Dayjs
    storeDate?: Dayjs
    forwardToShippingDate?: Dayjs
    pushToStockDate?: Dayjs
    transportId?: Guid
    transportSequence?: number
    departureLocationId: Guid
    departureDescription: string
    departureCoordinates: Location
    departureAddress: Address
    arrivalLocationId: Guid
    arrivalDescription: string
    arrivalCoordinates: Location
    arrivalAddress: Address
    inspectionRequired: boolean

    constructor({
        dto,
        forwardToShippingDate,
        pushToStockDate,
        departureLocation,
        arrivalLocation,
    }: {
        dto: IGetShippingOrderAssetDto
        forwardToShippingDate?: Dayjs
        pushToStockDate?: Dayjs
        departureLocation: RequestLocation
        arrivalLocation: RequestLocation
    }) {
        this.assetId = dto.assetId
        this.plannedAssetId = dto.plannedAssetId ?? undefined
        this.status = dto.status
        this.releaseDate = dto.releaseDate ? dayjs.utc(dto.releaseDate) : undefined
        this.storeDate = dto.storeDate ? dayjs.utc(dto.storeDate) : undefined
        this.transportId = dto.transportId || undefined
        this.transportSequence = typeof dto.transportSequence === "number" ? dto.transportSequence : undefined
        this.forwardToShippingDate = forwardToShippingDate
        this.pushToStockDate = pushToStockDate
        this.departureLocationId = dto.departureLocationId
        this.departureDescription = departureLocation.description
        this.departureCoordinates = departureLocation.coordinates
        this.departureAddress = departureLocation.address
        this.arrivalLocationId = dto.arrivalLocationId
        this.arrivalDescription = arrivalLocation.description
        this.arrivalCoordinates = arrivalLocation.coordinates
        this.arrivalAddress = arrivalLocation.address
        this.inspectionRequired = dto.inspectionRequired
    }

    get unplanned(): boolean {
        return this.assetId !== this.plannedAssetId
    }

    get isReleased(): boolean {
        return this.status === AssetShippingStatus.released
    }

    get isStored(): boolean {
        return this.status === AssetShippingStatus.stored
    }

    get isReleasedOrStored(): boolean {
        return this.isReleased || this.isStored
    }

    get isPushedToStock(): boolean {
        return !!this.pushToStockDate
    }

    get isForwardedToShipping(): boolean {
        return !!this.forwardToShippingDate
    }
}
